"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionModelAbstract = void 0;
const baseSlug_model_abstract_1 = require("../baseSlug.model.abstract");
class SessionModelAbstract extends baseSlug_model_abstract_1.BaseSlugModelAbstract {
    constructor(model) {
        super(model);
        this.idSession = 0;
        this.category = "";
        this.categories = null;
        this.certification = "";
        this.internalProductCode = "";
        this.productCode = "";
        this.endDate = null;
        this.startDate = null;
        this.isMainSession = false;
        this.alternativeSessions = [];
        this.alternativeStartDates = [];
        this.duration = 0;
        this.durationType = "";
        this.discountPercent = 0;
        this.previewUrl = "";
        this.previewUrlAlt = "";
        this.price = null;
        this.discountPrice = null;
        this.priceNoVat = null;
        this.location = "";
        this.approved = false;
        this.courseTypeFull = "";
        this.planType = "";
        this.title = "";
        this.onSale = false;
        this.onSaleLabel = "";
        this.stage = false;
        this.placement = false;
        this.lastSeats = false;
        this.lessionMode = "";
        this.buyButtonAvailable = false;
        this.soldOut = false;
        this.admissionForm = false;
        this.durationSlug = '';
        this.lessionModeSlug = '';
        this.promoDetailLabel = '';
        this.promoLabelStyle = '';
        this.tags = {};
        this.ranking = 0;
        this.credits_cfu = null;
        this.credits_cfp = null;
        this.admissionWithBuyAvailable = '';
        this.vatFree = false;
        this.certificationReleaseEntity = [];
        this.alwaysOn = false;
        this.lessonsAvailableImmediately = false;
        this.hasBonus = false;
        this.hasDiscount = false;
        this.urlCourse = null;
        this.hourDuration = null;
    }
    isEmpty() {
        return this.idSession == 0;
    }
}
exports.SessionModelAbstract = SessionModelAbstract;
//# sourceMappingURL=session.model.abstract.js.map